import React from "react";
import styled, { keyframes } from "styled-components";

interface AnimatedProps {
  animationDelay: number;
}
const slideIntoExistenceFromTheVoid = keyframes`
from {transform: scaleY(0);}
to {transform: scaleY(1);}
`;
const PurpleBar = styled.div<AnimatedProps>`
  background: var(--global-purple);
  border: 1.5px solid var(--global-purple);
  border-radius: 3px;
  width: 1px;
  height: auto;
  margin-bottom: 4px;
  margin-right: 8px;
  transform-origin: top;
  animation: ${slideIntoExistenceFromTheVoid} 0.6s ease-out
    ${(props: AnimatedProps) => `${props.animationDelay}s`} both;
`;

const fadeGoodTextIn = keyframes`
from {opacity: 0; transform: translateY(-10px);}
to {opacity: 1; transform: translateY(0);}
`;

const GoodText = styled.div<AnimatedProps>`
  font-size: var(--global-font-size-l);
  animation: ${fadeGoodTextIn} 0.6s ease-out
    ${(props: AnimatedProps) => `${props.animationDelay}s`} both;
`;

const fadeBadTextOut = keyframes`
from {opacity: 0; transform: translateY(-10px);}
to {opacity: 0.8; transform: translateY(0);}
`;

const BadText = styled.div<AnimatedProps>`
  color: var(--global-light-gray);
  font-size: var(--global-font-size-s);
  animation: ${fadeBadTextOut} 0.6s ease-out
    ${(props: AnimatedProps) => `${props.animationDelay}s`} both;
`;

const ListItem: React.FC<{ good: string; bad: string; index: number }> = ({
  good,
  bad,
  index,
}) => {
  const animationDelay = 0.2 + index * 0.3;
  return (
    <div style={{ display: "flex", marginBottom: "48px" }}>
      <PurpleBar animationDelay={animationDelay} />
      <div>
        <GoodText animationDelay={animationDelay}>{good}</GoodText>
        <BadText animationDelay={animationDelay}>{bad}</BadText>
      </div>
    </div>
  );
};

const INFO_LIST_CONTENT = [
  {
    bad: "Not proprietary and not only for legacy languages",
    good: "Open source, works on 20+ languages",
  },
  {
    bad: "Not vendor controlled",
    good: "Scan with 1,500+ community rules",
  },
  {
    bad: "No painful and complex DSL",
    good: "Write rules that look like your code",
  },
  {
    bad: "Don't wait hours or days for results",
    good: "Quickly get results in the terminal, editor, or CI/CD",
  },
  {
    bad: "Don't be forced to fix all existing issues just to get started",
    good: "Flag issues moving forward, get results in pull requests, Slack, + more",
  },
];

const InfoListDiv = styled.div`
  font-size: var(--global-font-size-m);
  line-height: 28px;
`;

const InfoList: React.FC = () => {
  return (
    <InfoListDiv>
      {INFO_LIST_CONTENT.map(({ bad, good }, index) => (
        <ListItem key={index} bad={bad} good={good} index={index} />
      ))}
    </InfoListDiv>
  );
};

export default InfoList;
